import moment from 'moment';
import React from 'react';
import Form from 'react-bootstrap/esm/Form';
import { useDispatch, useSelector } from 'react-redux';
import { IReducer } from '../../../../../../../../redux/configureStore';
import { setFinalDateOption } from '../../../../../../../../redux/fetchActions/legadoPage/clientsApp';
import Wrapper from '../../../../../../../../shared/components/Wrapper';

function SetFinalDate() {
  const dispatch = useDispatch();
  const clientsFilterState = useSelector(
    (reducer: IReducer) => reducer.clientsFilter
  );

  function setDate(event: React.FormEvent<any>) {
    const { value } = event.currentTarget;
    dispatch(setFinalDateOption(value));
  }

  return (
    <Wrapper.Default flexDirection="row" isActive>
      <span>Até:</span>
      <Form.Control
        type="date"
        style={{ width: '11rem', margin: '0 1rem 0 0.25rem' }}
        value={moment(clientsFilterState.finalDate).format('YYYY-MM-DD')}
        onChange={(event) => setDate(event)}
      />
    </Wrapper.Default>
  );
}

export default SetFinalDate;
